import  { useState } from 'react';
import {  MarketMaker, SourceRead } from '../../../../../api/apiTypes';
import { ConfirmValidationDialog } from '../../../../../utils/dialog/ConfirmValidationDialog';
import Swal from 'sweetalert2';
import SourcesAccordion from '../../../../../components/report/SourcesAccordion';
import {updateMarkerMaker, validaMarkerMaker } from '../../../../../api/functionApi';
import { useAxiosInterceptor } from '../../../../../api/wrappers';
import { formatTitle } from '../../../../../utils/Format';
import ElementGenerationsPanel from '../../../ElementGenerationsPanel';
import EventList from '../../../../../utils/EventList';

type ContainerListaDriverPageProps = {
  intermediario: MarketMaker;
  title: string;
  id: string;
  driverId: string;
  intermediarioId: string;
  sources: SourceRead[];
  events: any[];
};

const ContainerMarketMakerDettaglio = ({
  intermediario,
  title,
  id,
  driverId,
  intermediarioId,
  sources,
  events
}: ContainerListaDriverPageProps) => {


  useAxiosInterceptor(); // <--- monta l'interceptor

  const formattedTitle = formatTitle(title);

  const [values, setValues] = useState({
    market_maker : intermediario.value.market_maker ?? false,
    equity: intermediario.value.equity ?? false,
    bonds: intermediario.value.bonds ?? false,
    derivatives: intermediario.value.derivatives ?? false,
    etf: intermediario.value.etf ?? false,
    etc_etn: intermediario.value.etc_etn ?? false,
    warrants: intermediario.value.warrants ?? false,
    covered_warrants: intermediario.value.covered_warrants ?? false,
  });

  const [isEditing, setIsEditing] = useState(false);
  const [showDialogConfermaValidazione, setShowDialogConfermaValidazione] = useState(false);
  const [isIntermediarioValidato, setIsIntermediarioValidato] = useState(  intermediario.validation === "validated"
  );


  if (!intermediario) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="w-20 h-20 border-[6px] border-gray-300 border-t-textPrimary rounded-full animate-spin" />
      </div>
    );
  }

  const handleCheckboxChange = (field: keyof typeof values) => {
    setValues(prev => ({ ...prev, [field]: !prev[field] }));
  };



  const handleModifica = () => setIsEditing(true);
  const handleAnnulla = () => {
    // Reset ai valori iniziali
    setValues({
      market_maker : intermediario.value.market_maker ?? false,
      equity: intermediario.value.equity ?? false,
      bonds: intermediario.value.bonds ?? false,
      derivatives: intermediario.value.derivatives ?? false,
      etf: intermediario.value.etf ?? false,
      etc_etn: intermediario.value.etc_etn ?? false,
      warrants: intermediario.value.warrants ?? false,
      covered_warrants: intermediario.value.covered_warrants ?? false,

    });
    setIsEditing(false);
  };

  const handleSalva = async () => {

    const payload = {
      value: values,
    };

    try {
       await updateMarkerMaker(id, driverId, intermediarioId, payload);
      setIsEditing(false);
    setIsIntermediarioValidato(false);

      // Mostra un messaggio di successo all'utente.
      Swal.fire({
        icon: 'success',
        title: 'Modifica salvata!',
        text: 'Le modifiche sono state salvate correttamente.',
        confirmButtonColor: '#374151',
      });

    } catch (error) {
      console.error('Errore durante il salvataggio:', error);

      // Mostra un messaggio di errore in caso di fallimento.
      Swal.fire({
        icon: 'error',
        title: 'Errore nel salvataggio',
        text: 'Si è verificato un errore durante il salvataggio delle modifiche.',
        confirmButtonColor: '#374151',
      });
    }
  };


  const onClickValida = () => setShowDialogConfermaValidazione(true);

const handleValidazione = async () => {
  setShowDialogConfermaValidazione(false);

  // Mostra Swal di caricamento
  Swal.fire({
    title: 'Validazione in corso...',
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: () => {
      Swal.showLoading();
    }
  });

  try {
    await validaMarkerMaker(id, driverId, intermediarioId);
    setIsIntermediarioValidato(true);

    Swal.fire({
      icon: 'success',
      title: 'Validato!',
      text: 'L\'intermediario è stato validato con successo.',
      confirmButtonColor: '#374151',
    });
  } catch (error) {
    console.error('Errore durante la validazione:', error);

    Swal.fire({
      icon: 'error',
      title: 'Errore nella validazione',
      text: 'Si è verificato un errore durante la validazione dell\'intermediario.',
      confirmButtonColor: '#374151',
    });
  }
};


  return (
    <div className="bg-white rounded-xl border border-gray-200 p-8">
      <h1 className="text-4xl font-bold text-[#1B365D] mb-8">{formattedTitle}</h1>
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold text-[#1B365D]">{intermediario.name}</h1>
        <span className="font-medium text-gray-600 text-sm">Score: {intermediario.value.score.total_score}</span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6 mb-8">
        {Object.entries(values)
          .filter(([key]) => key !== 'score') // <--- Aggiungi questa riga per filtrare 'score'
          .map(([key, val]) => (
            <div key={key}>
              <label className="block text-sm font-medium text-gray-600 mb-1">
                {key.replace(/_/g, ' ').toUpperCase()}
              </label>
              <input
                type="text"
                value={key === 'market_maker' ? (val ? 'Sì' : 'No') : (val ? 'V' : '')}
                readOnly={!isEditing}
                onClick={() => isEditing && handleCheckboxChange(key as keyof typeof values)}
                className={`mt-1 block w-full rounded-md border border-gray-300 focus:border-[#1B365D] focus:ring focus:ring-[#1B365D]/20 p-2 ${isEditing ? 'bg-white cursor-pointer' : 'bg-gray-100'
                  }`}
              />
            </div>
          ))}
      </div>
 
         {!['approved', 'drafted', 'completed'].includes(intermediario.report_status ?? '') && (

      <div className="flex justify-end space-x-4">
        {!isEditing ? (
          (
            <>
              <button
                onClick={handleModifica}
                className="px-4 py-2 bg-[#1B365D] text-white hover:bg-[#142a4a] rounded-lg"
              >
                Modifica
              </button>
              <button
                onClick={onClickValida}
                  disabled={isIntermediarioValidato}
     className={`px-4 py-2 rounded 
            ${isIntermediarioValidato 
              ? 'bg-gray-200 text-gray-400 cursor-not-allowed' 
              : 'bg-textPrimary text-white hover:bg-textSecondary'}`
          }>
                Valida
              </button>
            </>
          )
        ) : (
          <>
            <button
              onClick={handleAnnulla}
              className="px-4 py-2 bg-gray-200 text-gray-800 hover:bg-gray-300 rounded"
            >
              Annulla
            </button>
            <button
              onClick={handleSalva}
              className="px-4 py-2 bg-[#1B365D] text-white hover:bg-[#142a4a] rounded-lg"
            >
              Salva
            </button>
          </>
        )}

        {showDialogConfermaValidazione && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
            <div className="bg-white p-6 rounded shadow-lg max-w-sm w-full">
              <ConfirmValidationDialog
                onConferma={handleValidazione}
                onAnnulla={() => setShowDialogConfermaValidazione(false)}
              />
            </div>
          </div>
        )}
      </div>
            )}

      <SourcesAccordion sources={sources} reportId={id} componentId={driverId} elementId={intermediarioId} />

            {/* Sezione Attività */}
<EventList events={events} />
      <ElementGenerationsPanel reportId={id} componentId={driverId} elementId={intermediarioId} />

    </div>
  );
};

export default ContainerMarketMakerDettaglio;
